<template>
    <v-dialog v-model="dialog">
        <v-card>
            <div id="relatorio" class="pa-5 pdf-content">

                <v-card-title>
                    Relatório de Resumo Comercial
                </v-card-title>

                <v-card-text>
                    <v-img
                        src="@/assets/logo_delta.jpg"
                        contain
                        height="100"
                        width="200"
                    />
                

                <v-card-subtitle>
                    Total de Orçamentos
                </v-card-subtitle>
                <v-simple-table dense class="mb-5">
                    <thead>
                        <tr>
                            <th width="30%">Total dos Orçamentos</th>
                            <th>Valor</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td width="30%">{{ salesOrderData.length }}</td>
                            <td>
                                {{ getSumSalesOrder.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                            </td>
                            <td>100,00</td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <!-- Bloco: Total por Tipo -->
                <v-card-subtitle>
                    Total por Tipo
                </v-card-subtitle>
                <v-simple-table dense class="mb-5">
                    <thead>
                        <tr>
                            <th width="30%">Tipo</th>
                            <th>QTD</th>
                            <th>Valor</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(salesOrder, index) in totaisPorTipo" :key="index">
                            <td width="30%">{{ salesOrder.nome }}</td>
                            <th>{{ salesOrder.qtd }}</th>
                            <td>{{ formatMoeda(salesOrder.valor) }}</td>
                            <td>{{ calculatePercentage(salesOrder.valor) }} %</td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <v-card-subtitle>
                    Total por Orçamentista
                </v-card-subtitle>
                <v-simple-table dense class="mb-5">
                    <thead>
                        <tr>
                            <th width="30%">Orçamentista</th>
                            <th>Qtd</th>
                            <th>Valor</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="orc in totaisPorOrcamentista" :key="orc.nome">
                            <td width="30%">{{ orc.nome }}</td>
                            <td>{{ orc.qtd }}</td>
                            <td>{{ formatMoeda(orc.valor) }}</td>
                            <td>{{ calculatePercentage(orc.valor) }} %</td>
                        </tr>
                    </tbody>
                </v-simple-table>


                <v-card-subtitle>
                    Total por Vendedor
                </v-card-subtitle>
                <v-simple-table dense class="mb-5">
                    <thead>
                        <tr>
                            <th width="30%">Nome</th>
                            <th>QTD</th>
                            <th>Valor</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(vendedor, index) in totaisPorVendedor" :key="index">
                            <td width="30%">{{ vendedor.nome }}</td>
                            <td>{{ vendedor.qtd }}</td>
                            <td>{{ formatMoeda(vendedor.valor) }}</td>
                            <td>{{ calculatePercentage(vendedor.valor) }} %</td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <!-- Resultado das Vendas -->
                <v-card-subtitle>
                    Resultado das Vendas
                </v-card-subtitle>
                <v-simple-table dense class="mb-5">
                    <thead>
                        <tr>
                            <th>Resultado das Vendas</th>
                            <th>Valor</th>
                            <th>QTD</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Total Vendido</td>
                            <td>{{ formatMoeda(totais?.totalVendido || 0) }}</td>
                            <td>{{  totais.qtdVendido }}</td>
                            <td>{{ calculatePercentage(totais?.totalVendido) }}</td>
                        </tr>
                        <tr>
                            <td>Total Perdido</td>
                            <td>{{ formatMoeda(totais?.totalPerdido || 0) }}</td>
                            <td>{{ totais.qtdPerdido }}</td>
                            <td>{{ calculatePercentage(totais?.totalPerdido) }}</td>
                        </tr>
                        <tr>
                            <td>Total em Análise</td>
                            <td>{{ formatMoeda(totais?.totalAnalise || 0) }}</td>
                            <td>{{ totais.qtdAnalise }}</td>
                            <td>{{ calculatePercentage(totais?.totalAnalise) }}</td>
                        </tr>
                        <tr>
                            <td>Total Orçado</td>
                            <td>{{ formatMoeda(totais?.totalOrcado || 0) }}</td>
                            <td>{{ totais.qtdOrcado }}</td>
                            <td>{{ calculatePercentage(totais?.totalOrcado) }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>

                </v-card-text>
            </div>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>   
                <v-btn color="primary" @click="exportPdf">Gerar PDF</v-btn>  
                <v-btn color="primary" @click="exportXls">Gerar XLS</v-btn>  
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import html2pdf from "html2pdf.js"
import * as XLSX from 'xlsx'

export default {
    props: ['isOpen', 'salesOrderData'],
    name: "ResumoComercial",
    data() {
        return {
            dialog: false,
            totais: {
                orcamentos: { qtd: 880, valor: 452103287.03 },
                totalVendido: 0,
                totalPerdido: 0,
                totalAnalise: 0,
                totalOrcado: 0,
                qtdVendido: 0,
                qtdPerdido: 0,
                qtdAnalise: 0,
                qtdOrcado: 0
            },
            totaisPorTipo: [],
            totaisPorOrcamentista: [],
            totaisPorVendedor: []
        }
    },

    computed: {
        getSumSalesOrder(){
            return this.salesOrderData.reduce((acc, curr) => acc + (curr._mirror_valor_sIPI_cICMS || 0), 0)
        }
    },

    methods: {
        formatMoeda(valor) {
            return Number(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        },

        exportPdf() {
            const elemento = document.getElementById("relatorio");
            html2pdf().set({
                margin: 10,
                filename: 'Resumo-Comercial.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            }).from(elemento).save();
        },

        exportXls(){
            const wsTotais = XLSX.utils.json_to_sheet([this.totais])
            const wsTipos = XLSX.utils.json_to_sheet(this.totaisPorTipo)
            const wsOrcamentistas = XLSX.utils.json_to_sheet(this.totaisPorOrcamentista)
            const wsVendedores = XLSX.utils.json_to_sheet(this.totaisPorVendedor)
            
            // Cria um workbook (arquivo Excel)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, wsTotais, "Totais")
            XLSX.utils.book_append_sheet(wb, wsTipos, "Por Tipo")
            XLSX.utils.book_append_sheet(wb, wsOrcamentistas, "Por Orçamentista")
            XLSX.utils.book_append_sheet(wb, wsVendedores, "Por Vendedor")

            // Converte em binário
            // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })

            XLSX.writeFile(wb, "tabela-contatos.xlsx");
        },

        calculatePercentage(value){
            return ((value / this.getSumSalesOrder) * 100).toFixed(2)
        }
    },

    watch: {
        isOpen(value){
            this.dialog = value
        },

        salesOrderData(data){

            console.log('Array ', data)

            // Totais
            this.totais.totalVendido = 0
            data.map((item) => {
                if(item.job.length > 0){
                    if(item.statusDescription == "PEDIDO COLOCADO"){
                        this.totais.totalVendido += item._mirror_valor_sIPI_cICMS
                        this.totais.qtdVendido += 1
                    } 
                    else if (item.statusDescription == "PERDIDO"){
                        this.totais.totalPerdido += item._mirror_valor_sIPI_cICMS
                        this.totais.qtdPerdido += 1
                    }
                    else if(item.statusDescription == "EM ANALISE"){
                        this.totais.totalAnalise += item._mirror_valor_sIPI_cICMS
                        this.totais.qtdAnalise += 1
                    } 
                    else if(item.statusDescription == "EM EXECUCAO"){
                        this.totais.totalOrcado += item._mirror_valor_sIPI_cICMS
                        this.totais.qtdOrcado += 1
                    }
                    
                }
            })

            // Por Tipo
            data.map((item) => {
                let tipo = item._mirror_tipo.split('-')[0]
                let index = this.totaisPorTipo.findIndex((tipoTotal) => tipoTotal.nome == tipo)
                
                if(index >= 0){
                    this.totaisPorTipo[index].valor = this.totaisPorTipo[index].valor + item._mirror_valor_sIPI_cICMS
                    this.totaisPorTipo[index].qtd += 1
                } else {
                    this.totaisPorTipo.push({
                        nome: tipo,
                        qtd: 1,
                        valor: item._mirror_valor_sIPI_cICMS
                    })
                }
            })

            // Por Orçamentista
            data.map((item) => {
                let orcamentistaNome = item.orcamentistaNome
                let index = this.totaisPorOrcamentista.findIndex((orc) => orc.nome == orcamentistaNome)
                
                if(index >= 0){
                    this.totaisPorOrcamentista[index].valor = this.totaisPorOrcamentista[index].valor + item._mirror_valor_sIPI_cICMS
                    this.totaisPorOrcamentista[index].qtd += 1
                } else {
                    this.totaisPorOrcamentista.push({
                        nome: orcamentistaNome,
                        valor: item._mirror_valor_sIPI_cICMS,
                        qtd: 1
                    })
                }
            })

            // Por Vendedor
            data.map((item) => {
                
                let vendedorNome = item.vendedorNome
                let index = this.totaisPorVendedor.findIndex((vend) => vend.nome == vendedorNome)
                
                if(index >= 0){
                    this.totaisPorVendedor[index].valor = this.totaisPorOrcamentista[index].valor + item._mirror_valor_sIPI_cICMS
                    this.totaisPorVendedor[index].qtd += 1
                } else {
                    this.totaisPorVendedor.push({
                        nome: vendedorNome,
                        valor: item._mirror_valor_sIPI_cICMS,
                        qtd: 1
                    })
                }
            })

            console.log('totaisPorOrcamentista ', this.totaisPorOrcamentista)
            console.log('totaisPorTipo >>> ', this.totaisPorTipo)
        }
    }
}
</script>

<style scoped>

.pdf-content {
  font-family: 'Arial', sans-serif;
  font-size: 5px;
  padding: 0;
}

</style>
